export const SKILL_ENTRY_FILENAME = "SKILL.md";
const BLOCKED_EXTENSIONS = new Set([
    ".sh", ".bash", ".zsh", ".fish", ".ps1", ".bat", ".cmd",
    ".py", ".rb", ".pl", ".php", ".lua", ".r",
    ".js", ".ts", ".mjs", ".cjs", ".jsx", ".tsx",
    ".exe", ".dll", ".so", ".dylib", ".bin",
    ".jar", ".class",
]);
export function parseSkillFrontmatter(content) {
    if (!content.startsWith("---")) {
        return { metadata: {}, body: content };
    }
    const end = content.indexOf("\n---", 3);
    if (end === -1) {
        return { metadata: {}, body: content };
    }
    const block = content.slice(3, end).trim();
    const body = content.slice(end + 4).replace(/^\r?\n/, "");
    const metadata = {};
    for (const line of block.split("\n")) {
        const colonIdx = line.indexOf(":");
        if (colonIdx === -1)
            continue;
        const key = line.slice(0, colonIdx).trim();
        const rawValue = line.slice(colonIdx + 1).trim();
        if (!key)
            continue;
        if (rawValue.startsWith("[") && rawValue.endsWith("]")) {
            const items = rawValue
                .slice(1, -1)
                .split(",")
                .map((s) => s.trim().replace(/^['"]|['"]$/g, ""))
                .filter(Boolean);
            metadata[key] = items;
        }
        else {
            metadata[key] = rawValue.replace(/^['"]|['"]$/g, "");
        }
    }
    return { metadata, body };
}
export function isSkillEntryFilename(filename) {
    const base = filename.split("/").pop() ?? filename;
    return base === SKILL_ENTRY_FILENAME;
}
export function validateSkillStructure(files) {
    const errors = [];
    const warnings = [];
    if (files.length === 0) {
        errors.push("Skill must contain at least one file.");
        return { valid: false, errors, warnings };
    }
    if (files.length > 30) {
        errors.push(`Skill may not contain more than 30 files (found ${files.length}).`);
    }
    const totalBytes = files.reduce((sum, f) => sum + f.content.length, 0);
    if (totalBytes > 2 * 1024 * 1024) {
        errors.push("Total skill size exceeds 2 MB.");
    }
    const entryFiles = files.filter((f) => isSkillEntryFilename(f.path));
    if (entryFiles.length === 0) {
        errors.push(`No entry file found. Skill must contain a file named "${SKILL_ENTRY_FILENAME}".`);
    }
    else if (entryFiles.length > 1) {
        errors.push(`Multiple files named "${SKILL_ENTRY_FILENAME}" found. Only one is allowed.`);
    }
    for (const f of files) {
        if (f.path.startsWith("/") || f.path.includes("..")) {
            errors.push(`File path "${f.path}" must be relative and not escape the skill folder.`);
            continue;
        }
        const ext = "." + (f.path.split(".").pop() ?? "");
        if (BLOCKED_EXTENSIONS.has(ext.toLowerCase())) {
            errors.push(`File "${f.path}" has a blocked extension (${ext}).`);
        }
    }
    if (entryFiles.length === 1) {
        const { metadata } = parseSkillFrontmatter(entryFiles[0].content);
        if (!metadata.description) {
            warnings.push(`${SKILL_ENTRY_FILENAME} has no "description" in its frontmatter.`);
        }
    }
    return { valid: errors.length === 0, errors, warnings };
}
export function skillTitleFromName(name) {
    return name
        .replace(/[-_]/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());
}
